import moment from "moment";
import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types";

import GaugeChart from "../generic/GaugePercentChart";
import { getLastWeek } from "./helpers";

interface Props {
  customerContacts: CustomerContactsState;
}

const GaugeChartContactsOfferAddressed: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [
    contactsWithNbaLastWeek,
    setContactsWithNbaLastWeek,
  ] = useState<number>();
  const [
    contactsOfferAddressedLastWeek,
    setContactsOfferAddressedLastWeek,
  ] = useState<number>();

  const { lastWeek, yearLastWeek, weekRangeString } = getLastWeek();

  useEffect(() => {
    const now = moment();
    const dataLastWeek = customerContacts.countPerInterval.find((interval) => {
      const d = moment(interval.date);
      return d.isoWeek() === lastWeek && d.isoWeekYear() === yearLastWeek;
    });
    if (dataLastWeek) {
      setContactsWithNbaLastWeek(dataLastWeek.countWithNba);
      setContactsOfferAddressedLastWeek(dataLastWeek.countOfferAddressed);
    }
  }, [customerContacts, lastWeek, yearLastWeek]);
  return (
    <GaugeChart
      value={contactsOfferAddressedLastWeek}
      maxValue={contactsWithNbaLastWeek}
      title={`Vergangene Woche (${weekRangeString}): Anteil Beratungsfokus angesprochen`}
      labelMaxValue="Kontakte mit Beratungsfokus vergangene Woche"
    />
  );
};

export default GaugeChartContactsOfferAddressed;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/GaugeChartOfferAddressed.tsx